import React, { lazy } from 'react';
import { Route } from 'react-router';
import routes from '../routes';
import Authenticated from '../../components/auth/Authenticated';

const RewardListScreen = lazy(() => import('../../screens/Reward/screens/List'));
const RewardCreateScreen = lazy(() => import('../../screens/Reward/screens/Create'));
const RewardEditScreen = lazy(() => import('../../screens/Reward/screens/Edit'));
const RewardRedemptionListScreen = lazy(() => import('../../screens/Reward/screens/Redemptions/RedemptionListScreen'));

const rewardRoutes = [
    <Route
        exact
        key={routes.REWARD_REDEMPTION_LIST}
        path={routes.REWARD_REDEMPTION_LIST}
        render={() => (
            <Authenticated redirectTo={routes.REWARD_LIST}>
                <RewardRedemptionListScreen />
            </Authenticated>
        )}
    />,

    <Route
        exact
        key={routes.REWARD_LIST}
        path={routes.REWARD_LIST}
        render={() => (
            <Authenticated redirectTo={routes.USER_LIST}>
                <RewardListScreen />
            </Authenticated>
        )}
    />,

    <Route
        exact
        key={routes.REWARD_CREATE}
        path={routes.REWARD_CREATE}
        render={() => (
            <Authenticated redirectTo={routes.REWARD_LIST}>
                <RewardCreateScreen />
            </Authenticated>
        )}
    />,

    <Route
        exact
        key={routes.REWARD_EDIT}
        path={routes.REWARD_EDIT}
        render={() => (
            <Authenticated redirectTo={routes.REWARD_LIST}>
                <RewardEditScreen />
            </Authenticated>
        )}
    />,
];

export default rewardRoutes;
